import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { setUserLogin } from '../Login/slice/userLoginSlice';
import { setHeaderDetails } from './headerSlice';
import { clearUserDetails } from '../Login/slice/userSlice';
import { userLogout } from './service';
import { Session } from '../../components/SessionTimeout/Session';
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import { Avatar, Box, Container, ListItemIcon, MenuItem, Typography } from '@mui/material';
import { images } from '../../config/images';
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonIcon from '@mui/icons-material/Person';
import "./header.css"

const Header = () => {

    const {
        firstName,
        lastName,
        email,
        company_logo,
    } = useSelector((state) => state.userState);

    const { isFullscreen } = useSelector((state) => state.headerState);
    const { selectTimeZoneProfile } = useSelector((state) => state.userState);
    const headerName = "Digital Vigilance"
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const dispatch = useDispatch();

    useEffect(() => {
        const updateDateTime = (timeZone) => {
            const tempDate = new Date();
            const options = {
                timeZone: timeZone || defaultTimeZone, // Use the selected time zone
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false, // 24-hour format
            };

            const formatter = new Intl.DateTimeFormat("en-US", options);

            document.getElementById("currentDateTime").textContent =
                formatter.format(tempDate);
        };

        updateDateTime(selectTimeZoneProfile);

        const intervalId = setInterval(
            () => updateDateTime(selectTimeZoneProfile),
            1000
        );

        return () => clearInterval(intervalId);
    }, [selectTimeZoneProfile]); // Re-run effect when selectTimeZoneProfile changes

    const openFullscreen = () => {
        const element = document.documentElement; // The target element for fullscreen

        if (!isFullscreen) {
            // Enter fullscreen
            const enterFullscreen = async () => {
                try {
                    if (element.requestFullscreen) {
                        await element.requestFullscreen();
                    } else if (element.webkitRequestFullscreen) {
                        await element.webkitRequestFullscreen();
                    } else if (element.msRequestFullscreen) {
                        await element.msRequestFullscreen();
                    }
                    dispatch(setHeaderDetails({ isFullscreen: true }));
                } catch (error) {
                    console.error("Fullscreen request failed:", error);
                }
            };
            enterFullscreen();
        } else {
            // Exit fullscreen
            const exitFullscreen = async () => {
                try {
                    // Check if we're actually in fullscreen mode
                    if (document.fullscreenElement || 
                        document.webkitFullscreenElement || 
                        document.msFullscreenElement) {
                        
                        if (document.exitFullscreen) {
                            await document.exitFullscreen();
                        } else if (document.webkitExitFullscreen) {
                            await document.webkitExitFullscreen();
                        } else if (document.msExitFullscreen) {
                            await document.msExitFullscreen();
                        }
                    }
                    dispatch(setHeaderDetails({ isFullscreen: false }));
                } catch (error) {
                    console.error("Fullscreen exit failed:", error);
                }
            };
            exitFullscreen();
        }
    };
    const defaultTimeZone = "Asia/Kolkata"; // Default to a valid time zone if needed
    const handleLogOut = async () => {

        try {
            const resp = await userLogout();

            if (resp.status === 200 || resp.status === 201) {
                dispatch(setUserLogin({ userName: null }));
                dispatch(clearUserDetails());
                navigate("/");
                window.location.reload(false);
                localStorage.clear();
            } else {
                console.error("Logout failed with status:", resp.status);
            }
        }
        catch (error) {
            console.error("Error occurred during logout:", error);
        }
    };

    return (
        <>
            <Session />
            <AppBar position="static" className="header-wrapper">
                <Container maxWidth="none">
                    <Toolbar disableGutters className="toolbarWrap">
                        <div className="headerTitle-wrap">
                            <Typography
                                variant="h6"
                                noWrap
                                component="a"
                                onClick={() => {
                                    navigate("/");
                                }}
                            >
                                <img src={company_logo ? company_logo : images.logo} alt="logo" className="headerLogo" />
                            </Typography>
                            <div className='header-name'>{headerName}</div>
                        </div>

                        <Box sx={{ flexGrow: 0 }} className="headerToolbar-wrap">
                            <div className="dateTime-wrap">
                                <p id="currentDateTime"></p>
                            </div>
                            <div
                                className="expandScreen-btn exclude-me"
                                onClick={openFullscreen}
                                style={{ cursor: "pointer" }}
                            >
                                {isFullscreen ? (
                                    <img src={images.minimseScreen} alt="Minimize Screen" />
                                ) : (
                                    <img src={images.expandScreen} alt="Expand Screen" />
                                )}
                            </div>
                            <div
                                onClick={handleClick}
                                className="profileToggle-menu exclude-me"
                            >
                                <Avatar
                                    alt=""
                                    src={images.profileImage}
                                    className="profile-toggle-img"
                                />
                                <p className="profileName">
                                    {firstName} {lastName}
                                </p>
                                <KeyboardArrowDownIcon className="ToggleIcon" />
                            </div>
                            <Menu
                                anchorEl={anchorEl}
                                id="account-menu"
                                open={open}
                                onClose={handleClose}
                                onClick={handleClose}
                                PaperProps={{
                                    elevation: 0,
                                    sx: {
                                        overflow: "visible",
                                        filter: "drop-shadow(0px 2px 8px rgb(84, 108, 138))",
                                        mt: 1.5,
                                        "& .MuiAvatar-root": {
                                            width: 32,
                                            height: 32,
                                            ml: -0.5,
                                            mr: 1,
                                        },
                                        "&:before": {
                                            content: '""',
                                            display: "block",
                                            position: "absolute",
                                            top: -27,
                                            right: 0,
                                            width: 0,
                                            height: 0,
                                            borderLeft: "25px solid transparent",
                                            borderRight: "25px solid transparent",
                                            borderBottom: "50px solid #fff",
                                            zIndex: 0,
                                        },
                                    },
                                    "& .MuiMenu-list": {
                                        maxHeight: "calc(100vh - 64px)",
                                        overflowY: "auto",
                                    },
                                    "@media screen and (max-height: 500px)": {
                                        "& .MuiMenu-list": {
                                            maxHeight: "calc(100vh - 100px)",
                                        }
                                    }
                                }}
                                transformOrigin={{ horizontal: "right", vertical: "top" }}
                                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                            >
                                <MenuItem>
                                    <div className="profile-item">
                                        <Avatar alt="" src={images.profileImage} className="profile-image" />
                                        <div className="profile-detail">
                                            <p className="userName">
                                                {firstName} {lastName}
                                            </p>
                                            <p className="userEmail">{email}</p>
                                        </div>
                                    </div>
                                </MenuItem>
                                <Divider />
                                <MenuItem
                                    className="menu-item"
                                    sx={{ px: 3, py: 2 }}
                                    onClick={() => { navigate("/userprofile") }}
                                >
                                    <ListItemIcon>
                                        <PersonIcon fontSize="small" />
                                    </ListItemIcon>
                                    Profile
                                </MenuItem>
                                <MenuItem
                                    className="menu-item"
                                    sx={{ px: 3, py: 2 }}
                                    onClick={() => navigate("/change-password")}
                                >
                                    <ListItemIcon>
                                        <img src={images.passwordImg} alt="" class />
                                    </ListItemIcon>
                                    Change Password
                                </MenuItem>
                                <MenuItem
                                    className="menu-item"
                                    sx={{ px: 3, py: 2 }}
                                    onClick={() => handleLogOut()}
                                >
                                    <ListItemIcon>
                                        <LogoutIcon fontSize="small" />
                                    </ListItemIcon>
                                    Logout
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    );
}

export default Header;
